<dx-data-grid
    rowAlternationEnabled="true"
    hoverStateEnabled="true"
    loadPanel="false"
    [height]="height"
    [showBorders]="true"
    [columnAutoWidth]="true"
    [dataSource]="dataSource"
    [columns]="columns"
    [keyExpr]="keyExpr"
    [(selectedRowKeys)]="selectedRowKeys"
    [allowColumnReordering]="allowColumnReordering"
    [allowColumnResizing]="allowColumnResizing"
    [showColumnHeaders]="showColumnHeaders"
    (onExporting)="onExporting($event)"
    (onSelectionChanged)="onSelectionChanged($event)"
    (onInitNewRow)="onInitNewRow($event)"
    (onRowClick)="onRowClicked($event)"
    (onRowDblClick)="onRowDblClicked($event)"
    (onContextMenuPreparing)="onContextMenuPreparing($event)"
    (onCellPrepared)="onCellPrepared($event)"
    (onRowInserting)="onRowInserting($event)"
    (onRowUpdating)="onRowUpdating($event)"
    (onRowRemoving)="onRowRemoving($event)"
    (onToolbarPreparing)="toolbarPreparing.emit($event)"
    (onEditorPreparing)="onEditorPreparing($event)"
    (onEditingStart)="onEditingStart($event)">
    <dxo-paging [enabled]="hasPaging" [pageSize]="pageSize"></dxo-paging>
    <dxo-search-panel [visible]="hasSearch"></dxo-search-panel>
    <dxo-header-filter [visible]="hasFilter"></dxo-header-filter>
    <dxo-selection showCheckBoxesMode="always" [mode]="selectionMode" [allowSelectAll]="allowSelectAll"></dxo-selection>
    <dxo-export [enabled]="hasExport"></dxo-export>
    <dxo-group-panel [visible]="hasGrouping"></dxo-group-panel>
    <dxo-grouping [autoExpandAll]="true"></dxo-grouping>
    <dxo-summary [groupItems]="groupItems"></dxo-summary>
    <dxo-editing [mode]="editMode" [useIcons]="true" [allowAdding]="allowAdding" [allowUpdating]="allowUpdating" [allowDeleting]="allowDeleting"></dxo-editing>
    <dxo-column-chooser [enabled]="hasColumnChooser"></dxo-column-chooser>
</dx-data-grid>
